export const isAndroid = (): boolean => {
    return /(android)/i.test(window.navigator.userAgent);
};
